import React from "react";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import PaymentDetails from "../../ordersForBuyForMe/paymentDetials";
import CustomPrivacySection from "../../ordersForBuyForMe/customPrivacySection";
import CustomBuyForMeButtonOrders from "../../ordersForBuyForMe/customOrderBuyButton";

const PaymentSection = ({
  cart,
  onPayCart,
  onDeleteCart,
  onUpdateCart,
  direction,
  t,
}) => {
  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, "0")}:${m
      .toString()
      .padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  const getTimeDisplay = () => {
    if (cart?.status === "pending") {
      return t("Waiting");
    }

    const timeRemaining = Math.max(
      0,
      Math.floor((new Date(cart?.timeLeft).getTime() - Date.now()) / 1000)
    );

    return formatTime(timeRemaining);
  };

  const getStatusText = () => {
    return cart?.status === "priced"
      ? { en: "pending payment", ar: "تم التسعير" }
      : { en: "Pending Pricing", ar: "بانتظار التسعير" };
  };

  const handleCheckChange = (newValue) => {
    onUpdateCart(cart._id, {
      isCheck: newValue,
      flagIsCheck: {},
    });
  };
  // console.log(cart);
  return (
    <div className="w-full pt-6 mt-4">
      <PaymentDetails
        time={getTimeDisplay()}
        couponValue={cart?.couponDiscount}
        usedCoupon={cart?.isUsedCoupon}
        status={getStatusText()}
        cardStatus={cart?.status}
        priceInside={cart?.totalDShippingFees}
        totalPrice={cart?.totalCartPriceBeforeFees}
        totalPriceWithFees={cart?.markaShipFees}
        finalPrice={cart?.totalCartPrice}
      />

      {cart?.status === "priced" && (
        <>
          <CustomPrivacySection
            isChecked={cart?.isCheck}
            onCheckChange={handleCheckChange}
          />

          <div className="flex items-center justify-between gap-4 mt-4">
            <CustomBuyForMeButtonOrders
              children={t("proceed_to_payment")}
              icon={ArrowLeftIcon}
              bgColor="bg-custom-yellow"
              textColor="text-black"
              iconColor="text-black"
              onClick={() => onPayCart(cart._id)}
              direction={direction}
            />

            <CustomBuyForMeButtonOrders
              children={t("CancelShipment")}
              icon={ArrowLeftIcon}
              bgColor="bg-red-600"
              textColor="text-white"
              iconColor="text-white"
              onClick={() => onDeleteCart(cart._id)}
              direction={direction}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default PaymentSection;
